require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-weymouth-bid.json") })
        }
      }, "path---authors-weymouth-bid");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-weymouth-bid!./.cache/json/authors-weymouth-bid.json
// module id = 1358
// module chunks = 231608221292675